<template>
  <transition name="qs-modal-fade">
    <div
      v-show="modalActive"
      class="qs-modal"
      role="dialog"
      aria-modal="true"
      @click.self="closeModal"
    >
      <transition name="qs-modal-zoom">
        <div v-show="modalActive" class="qs-modal-inner">
          <button class="qs-modal-close" type="button" aria-label="Cerrar" @click="closeModal">
            <i class="far fa-times-circle"></i>
          </button>

          <!-- 👇 Scroll aquí, no en toda la página -->
          <div class="qs-modal-body">
            <slot />
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ModalServicio",
  props: {
    modalActive: { type: Boolean, default: false },
    // 👇 “colchón” extra por si hay barra inferior / footer fijo
    bottomOffset: { type: Number, default: 84 },
  },
  emits: ["cerrar-modal"],
  mounted() {
    // Exponemos la variable CSS para el padding inferior
    document.documentElement.style.setProperty("--qs-bottom-offset", `${this.bottomOffset}px`);

    // ✅ FIX Android/Chrome: picker nativo (time/date) se descuadra con overflow/fixed
    const modal = this.$el; // root = .qs-modal
    if (!modal) return;

    const onFocusIn = (e) => {
      const t = e.target;
      if (t && (t.type === "time" || t.type === "date")) {
        modal.classList.add("qs-no-overflow");
      }
    };

    const onFocusOut = (e) => {
      const t = e.target;
      if (t && (t.type === "time" || t.type === "date")) {
        setTimeout(() => modal.classList.remove("qs-no-overflow"), 250);
      }
    };

    modal.addEventListener("focusin", onFocusIn);
    modal.addEventListener("focusout", onFocusOut);

    this._qsCleanup = () => {
      modal.removeEventListener("focusin", onFocusIn);
      modal.removeEventListener("focusout", onFocusOut);
    };
  },
  beforeUnmount() {
    if (this._qsCleanup) this._qsCleanup();
  },
 watch: {
  bottomOffset(v) {
      document.documentElement.style.setProperty("--qs-bottom-offset", `${v}px`);
    },
    modalActive(v) {
      // ✅ cada vez que se cierre, limpia el estado
      if (!v && this.$el) this.$el.classList.remove("qs-no-overflow");
    },
  },
  methods: {
    closeModal() {
      // ✅ por si quedó pegada la clase
      if (this.$el) this.$el.classList.remove("qs-no-overflow");
      this.$emit("cerrar-modal");
    },
  },
};
</script>

<style scoped>
/* Fondo + contenedor full-screen */
.qs-modal {
  position: fixed;
  inset: 0;
  z-index: 999999; /* 🔥 más alto que cualquier footer típico */
  background: rgba(0, 0, 0, 0.45);

  display: flex;
  justify-content: center;
  align-items: flex-start;

  /* ✅ Importantísimo en móvil */
  padding: 14px 12px calc(14px + env(safe-area-inset-bottom) + var(--qs-bottom-offset, 84px));
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

/* Caja del modal */
.qs-modal-inner {
  width: 100%;
  max-width: 980px;
  margin: 0 auto;

  background: var(--q-card);
  border-radius: 16px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.25);

  /* ✅ evita que “se salga” en móviles */
  max-height: calc(100dvh - 28px);
  overflow: hidden;

  position: relative;
}

/* Cerrar arriba derecha */
.qs-modal-close {
  position: absolute;
  top: 10px;
  right: 12px;
  background: transparent;
  border: 0;
  cursor: pointer;
  font-size: 22px;
  z-index: 2;
}

/* Aquí vive el scroll */
.qs-modal-body {
  padding: 18px 16px 18px 16px;
  overflow-y: auto;
  max-height: calc(100dvh - 28px);
}

/* Pantalla pequeña: modal full-screen */
@media (max-width: 480px) {
  .qs-modal {
    padding: 0;
    align-items: flex-start;
  }
  .qs-modal-inner {
    border-radius: 0;
    max-height: 100dvh;
    max-width: 100%;
  }
  .qs-modal-body {
    max-height: calc(100dvh - env(safe-area-inset-bottom, 0px));
  }
}

/* Animaciones suaves */
.qs-modal-fade-enter-active,
.qs-modal-fade-leave-active {
  transition: opacity 0.2s ease;
}
.qs-modal-fade-enter-from,
.qs-modal-fade-leave-to {
  opacity: 0;
}

.qs-modal-zoom-enter-active,
.qs-modal-zoom-leave-active {
  transition: transform 0.2s ease, opacity 0.2s ease;
}
.qs-modal-zoom-enter-from,
.qs-modal-zoom-leave-to {
  transform: translateY(8px) scale(0.98);
  opacity: 0;
}
</style>